
namespace SorAraBul.Definitions {

    @Serenity.Decorators.registerClass()
    export class RestrictionsDialog extends Serenity.EntityDialog<RestrictionsRow, any> {
        protected getFormKey() { return RestrictionsForm.formKey; }
        protected getIdProperty() { return RestrictionsRow.idProperty; }
        protected getLocalTextPrefix() { return RestrictionsRow.localTextPrefix; }
        protected getNameProperty() { return RestrictionsRow.nameProperty; }
        protected getService() { return RestrictionsService.baseUrl; }
        protected getDeletePermission() { return RestrictionsRow.deletePermission; }
        protected getInsertPermission() { return RestrictionsRow.insertPermission; }
        protected getUpdatePermission() { return RestrictionsRow.updatePermission; }

        protected form = new RestrictionsForm(this.idPrefix);

    }
}